export const ACTION_BUTTONS = ['High', 'Right', 'Low']
